<template>
  <div class="w-container">
    <h-header />
    <!-- Home Page
    ==========================================-->
    <div id="tf-home" class="text-center">
        <div class="overlay">
          <div class="container down-line text-left">
            <div class="row">
              <div class="navbar" style="    padding-left: 30px;">
                <a href="javascript:void(0);" class="download-btn">立即下载</a>
              </div>
            </div>
          </div>
            <div class="content">
                <h1>科技元宇宙</h1>
                <p class="lead">引领科技、探索、创新</p>
                <!-- <button type="submit" class="w-page-down">软件下载<i class="fa fa-download w-font-down" aria-hidden="true"></i></button> -->
                <!-- <a href="#tf-about" class="fa fa-angle-down page-scroll"></a> -->
            </div>
        </div>
    </div>
    <!-- Services Section
    ==========================================-->
    <div id="tf-services" class="text-center">
        <div class="container">
            <div class="section-title center">
                <h2><strong>四旋翼赛事</strong></h2>
                <div class="line"><hr></div>
                <div class="clearfix"></div>
                <!-- <small><em>随着元宇宙的普及、科技与生活的结合变得更加紧密，我们用数字孪生技术，为各行各业创造着无限的可能性...</em></small> -->
            </div>
            <div class="space"></div>
            <div id="J-UVA" class="owl-carousel owl-theme">
                <div class="item">
                  <div class="row">
                    <div class="col-md-3 col-sm-6 service" @click="navigateTo('/work/uva?type=XWL')">
                        <!-- <i class="fa fa-mobile"></i> -->
                        <img src="/work/static/img/services/xwl-icon.png" alt="旋翼赛物流搬运赛竞赛规则（XWL）" class="ser-img">
                        <h4><strong>物流搬运赛（XWB）</strong></h4>
                        <p>了解详情</p>
                    </div>
                    <div class="col-md-3 col-sm-6 service" @click="navigateTo('/work/uva?type=XTJ')">
                        <!-- <i class="fa fa-camera"></i> -->
                        <img src="/work/static/img/services/xtj-icon.jpg" alt="旋翼赛团队接力赛" class="ser-img">
                        <h4><strong>团体接力赛（XTJ）</strong></h4>
                        <p>了解详情</p>
                    </div>
                    <div class="col-md-3 col-sm-6 service" @click="navigateTo('/work/uva?type=XKG')">
                        <!-- <i class="fa fa-camera"></i> -->
                        <img src="/work/static/img/services/xkg-icon.jpg" alt="空中格斗赛" class="ser-img">
                        <h4><strong>空中格斗赛（XKG）</strong></h4>
                        <p>了解详情</p>
                    </div>
                    <div class="col-md-3 col-sm-6 service" @click="navigateTo('/work/uva?type=XKZ')">
                        <!-- <i class="fa fa-desktop"></i> -->
                        <img src="/work/static/img/services/xkz-icon.jpg" alt="旋翼赛空中足球赛" class="ser-img">
                        <h4><strong>空中足球赛（XKZ）</strong></h4>
                        <p>了解详情</p>
                    </div>
                  </div>
                </div>

                <div class="item">
                  <div class="row">
                    <div class="col-md-3 col-sm-6 service none" @click="navigateTo('/work/uva?type=XWL')">
                        <!-- <i class="fa fa-mobile"></i> -->
                        <img src="/work/static/img/services/xwl-icon.png" alt="旋翼赛物流搬运赛竞赛规则（XWL）" class="ser-img">
                        <h4><strong>旋翼赛物流搬运赛竞赛规则（XWL）</strong></h4>
                        <p>了解详情</p>
                    </div>
                    <div class="col-md-3 col-sm-6 service" @click="navigateTo('/work/uva?type=XGF')">
                        <!-- <i class="fa fa-desktop"></i> -->
                        <img src="/work/static/img/services/xgf-icon.png" alt="个人飞行赛（XGF）" class="ser-img">
                        <h4><strong>个人飞行赛（XGF）</strong></h4>
                        <p>了解详情</p>
                    </div>
                    <div class="col-md-3 col-sm-6 service" @click="navigateTo('/work/uva?type=XKS')">
                        <!-- <i class="fa fa-camera"></i> -->
                        <img src="/work/static/img/services/xks-icon.png" alt="旋翼赛个人空中射击赛竞赛规则（XKS）" class="ser-img">
                        <h4><strong>个人空中射击赛（XKS）</strong></h4>
                        <p>了解详情</p>
                    </div>
                    <div class="col-md-3 col-sm-6 service none" @click="navigateTo('/work/uva?type=GKZ')">
                        <!-- <i class="fa fa-camera"></i> -->
                        <img src="/work/static/img/services/gkz-icon.png" alt="固定翼赛空中侦察赛竞赛规则（GKZ）" class="ser-img">
                        <h4><strong>固定翼赛空中侦察赛竞赛规则（GKZ）</strong></h4>
                        <p>了解详情</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <div id="services"  class="text-center">
        <div class="container text-center">
          <div class="section-title center">
              <h2>无人机设计</h2>
              <div class="line"><hr>
            </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-6">
                    <div class="service" @click="navigateTo('/work/uva?type=design')">
                        <img src="/work/static/img/services/t3.jpg" alt="" width="90%">
                        <h4>无人机数字孪生体模型的设计</h4>
                        <p><a href="javascript:void(0);">了解详情</a></p>
                    </div>
                </div>

                <div class="col-md-6 col-sm-6">
                    <div class="service" @click="navigateTo('/work/uva?type=verification')">
                        <img src="/work/static/img/services/t4.jpg" alt="" width="90%">
                        <h4>无人机数字孪生飞行验证</h4>
                        <p><a href="javascript:void(0);">了解详情</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Clients Section
    ==========================================-->
    <div id="tf-clients" class="text-center">
        <div class="overlay">
            <div class="container">
                <div class="section-title center">
                    <h2>MBSE数字孪生</h2>
                    <!-- <div class="row section-sub-title">
                      <div class="col-md-4 col-md-offset-2"><h3>1.快速接入元宇宙</h3></div>
                      <div class="col-md-4"><h3>2.建立属于自己的元宇宙</h3></div>
                    </div> -->
                    <div class="line"> <hr></div>
                </div>
                <div class="row">
                  <div class="col-md-10 col-md-offset-1">
                    <!-- <div class="col-md-6 "></div> -->
                    <div :class="'col-md-4 col-xs-6 client-items ' + (item.active ? 'active' : '')" v-for="(item,index) in clientData" :key="'aa-' + index" @click="chooseSwiper(index)">
                      <img :src="item.paginationImage" :alt="item.title">
                      <div class="text" v-text="item.title">全球互联</div>
                    </div>
                  </div>
                </div>
                <div class="row text-left" style="margin-top:10px;">
                    <div class="col-md-10 col-md-offset-1">
                      <div id="clients" class="owl-carousel owl-theme">
                        <div class="item">
                          <div class="owl-ctt">
                            <p>MBSE技术是国际系统工程学会（INCOSE）2008年在“系统工程2020愿景”中正式提出，即建模方法在系统工程中的形式化应用，用以支持在系统全生命周期内开展需求、设计、分析、验证和确认相关的活动。</p>
                            <p>目前是国际顶尖的高端装备研发机构以及工业软件研发单位构使用的最前沿系统工程技术。</p>
                            <p>工信部2021年11月30日发布的《“十四五”信息化和工业化深度融合发展规划》中提出推进MBSE规模应用，“构建面向装备全生命周期的数字孪生系统，推进基于模型的系统工程（MBSE）规模应用，依托工业互联网平台实现装备的预测性维护与健康管理。”</p>
                          </div>
                          <img src="/work/static/img/swiper/t1-new.jpg" alt="MBSE" width="100%">
                        </div>
                        <div class="item">
                          <div class="owl-ctt">
                            <p>数字孪生体模型是对具有空间属性及物理属性的物理实物的数字化映射，是按照物理实物的系统结构组织的计算机可识别与运行的多尺度数字孪生体模型与多维度模型（信息域模型、能量域模型、物质域模型）组成的相关联的模型集合。</p>
                          </div>
                          <img src="/work/static/img/swiper/t2-new.png" alt="数字孪生体模型" width="100%">
                        </div>
                        <div class="item">
                          <div class="owl-ctt">
                            <p>模型操作系统（ModelOS）是运行于操作系统之上的一种次级操作系统（Meta Operating System），为数字孪生体模型提供统一的运行与管理平台。</p>
                            <p>模型操作系统为数字孪生体模型中各尺度子数字孪生体模型以及信息域、能量域、物质域的多维度模型提供统一的运行与同步管理机制，并在数字时空中完整映射对应物理实体的信息流、能量流以及物质流的变化过程。</p>
                            <p>模型操作系统为数字孪生体模型提供三维几何空间管理以及统一的时间管理，并实现信息物理系统抽象层为数字孪生体模型与对应物理实体的实时数字孪生映射提供虚实数据交互机制。</p>
                          </div>
                          <img src="/work/static/img/swiper/t3-new.jpg" alt="模型操作系统" width="100%">
                        </div>
                          <!-- <div class="item"   v-for="(item,index) in clientData" :key="'bb-' + index">
                            <img :src="item.swiperImage" class="client-img">
                          </div> -->
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Testimonials Section
    ==========================================-->
    <div id="tf-testimonials" class="text-center none">
        <div class="overlay">
            <div class="container">
                <div class="section-title center">
                    <h2>用户说</h2>
                    <div class="line"><hr></div>
                </div>
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <div id="testimonial" class="owl-carousel owl-theme">
                            <div class="item">
                                <h5>第一次体验VSWORK就在公司推行使用，一直用到现在。通过线上VR联系人管理，让「广告门」的用户管理体系非常快捷高效地建立起来！</h5>
                                <p><strong>苗浩广告门</strong>联合创办人&主编</p>
                            </div>

                            <div class="item">
                                <h5>第一次体验VSWORK就在公司推行使用，一直用到现在。通过线上VR联系人管理，让「广告门」的用户管理体系非常快捷高效地建立起来！</h5>
                                <p><strong>苗浩广告门</strong>联合创办人&主编</p>
                            </div>

                            <div class="item">
                                <h5>第一次体验VSWORK就在公司推行使用，一直用到现在。通过线上VR联系人管理，让「广告门」的用户管理体系非常快捷高效地建立起来！</h5>
                                <p><strong>苗浩广告门</strong>联合创办人&主编</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
        </div>
    </div>

    <!-- Contact Section
    ==========================================-->
    <div id="tf-contact" class="text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 col-md-offset-2">
                    <div class="section-title center">
                      <h2><strong>我们的合作伙伴</strong></h2>
                      <div class="line"><hr></div>
                      <div class="clearfix"></div>
                      <!-- <small><em>VSWORK虚拟空间团队保持开放、创新、求真、务实的发展合作理念，与广大合作伙伴实现共赢。</em></small>             -->
                    </div>
                </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="newsBox">
                      <div class="thumbnail">
                          <figure><img src="/work/static/img/team/t2.jpg" alt="中国航空学会"></figure>
                          <div class="caption maxheight2">
                          <div class="box_inner">
                                      <div class="box">
                                          <p class="title"></p><h5>中国航空学会</h5><p></p>
                                          <!-- <p>提供世界上公开的已知航天器轨道信息，追踪航天器运行状况，历史大事记的专业网站。</p> -->
                                      </div> 
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="newsBox">
                  <div class="thumbnail">
                      <figure><img src="/work/static/img/team/t4.jpg" alt="福建省航空学会"></figure>
                      <div class="caption maxheight2">
                        <div class="box_inner">
                            <div class="box">
                                <p class="title"></p><h5>福建省航空学会</h5><p></p>
                                <!-- <p>福建省航空学会成立于1986年12月，是全省航空航天行业的院校、科研院所、企事业单位、部队及热心于航空航天发展的其他行业等的人士，自愿结合组成的行业性、学术性、科普性的社会团体，是中国航空学会的一个分支组织。业务上接受中国航空学会的指导，同时接受主管单位—福建省科学技术协会的业务指导和监督管理。</p> -->
                            </div> 
                        </div>
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="newsBox">
                  <div class="thumbnail">
                      <figure><img src="/work/static/img/team/t1.jpg" alt="中国指挥控制学会"></figure>
                      <div class="caption maxheight2">
                        <div class="box_inner">
                            <div class="box">
                                <p class="title"></p><h5>中国指挥控制学会</h5><p></p>
                                <!-- <p>《国家地理》杂志自1888年诞生以来，从珠峰之巅到大洋深处，从显微镜下的世界到遥远星系的恒星，这本杂志已经对“世界和世界上的一切”报道了130多年。那些令人难忘的影像纪实、严谨真实的文字报道、精密准确的地图绘制，深受全球无数地区的读者喜爱，更使“广义地理”这一概念深入人心。</p> -->
                            </div> 
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="newsBox">
                        <div class="thumbnail">
                            <figure><img src="/work/static/img/team/t5.jpg" alt="中国图象图形学学会"></figure>
                            <div class="caption maxheight2">
                            <div class="box_inner">
                                        <div class="box">
                                            <p class="title"></p><h5>中国图象图形学学会</h5><p></p>
                                            <!-- <p>提供世界上公开的已知航天器轨道信息，追踪航天器运行状况，历史大事记的专业网站。</p> -->
                                        </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="newsBox">
                    <div class="thumbnail">
                        <figure><img src="/work/static/img/team/t6.jpg" alt="虚拟仿真实验教学创新联盟"></figure>
                        <div class="caption maxheight2">
                        <div class="box_inner">
                            <div class="box">
                                <p class="title"></p><h5>虚拟仿真实验教学创新联盟</h5><p></p>
                                <!-- <p>福建省航空学会成立于1986年12月，是全省航空航天行业的院校、科研院所、企事业单位、部队及热心于航空航天发展的其他行业等的人士，自愿结合组成的行业性、学术性、科普性的社会团体，是中国航空学会的一个分支组织。业务上接受中国航空学会的指导，同时接受主管单位—福建省科学技术协会的业务指导和监督管理。</p> -->
                            </div> 
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="newsBox">
                  <div class="thumbnail">
                      <figure><img src="/work/static/img/team/t3.jpg" alt="西安电子科技大学"></figure>
                      <div class="caption maxheight2">
                      <div class="box_inner">
                          <div class="box">
                              <p class="title"></p><h5>西安电子科技大学</h5><p></p>
                              <!-- <p>福建省航空学会成立于1986年12月，是全省航空航天行业的院校、科研院所、企事业单位、部队及热心于航空航天发展的其他行业等的人士，自愿结合组成的行业性、学术性、科普性的社会团体，是中国航空学会的一个分支组织。业务上接受中国航空学会的指导，同时接受主管单位—福建省科学技术协会的业务指导和监督管理。</p> -->
                          </div> 
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
    <h-footer />
  </div>
</template>
<script>
import Header from '../../components/header'
import Footer from '../../components/footer'

var clientIns = null

function main() {
   'use strict';

  var $ = window.$

  /* ==============================================
  Testimonial Slider
  =============================================== */ 

  $('a.page-scroll').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top - 40
          }, 900);
          return false;
        }
      }
    });

  $(document).ready(function() {
    $("#team").owlCarousel({
    
        navigation : false, // Show next and prev buttons
        slideSpeed : 300,
        paginationSpeed : 400,
        autoHeight : true,
        itemsCustom : [
              [0, 1],
              [450, 2],
              [600, 2],
              [700, 2],
              [1000, 4],
              [1200, 4],
              [1400, 4],
              [1600, 4]
            ],
    });

    clientIns = $("#clients").owlCarousel({
        navigation : false,
        slideSpeed : 300,
        paginationSpeed : 400,
        singleItem:true,
        pagination: false
    });

    $("#testimonial").owlCarousel({
      navigation : true, // Show next and prev buttons
      navigationText: ['上一张', '下一张'],
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem:true,
      autoPlay: true,
      pagination: false
      // navigation: true
    });

    $("#J-UVA").owlCarousel({
      navigation : true, // Show next and prev buttons
      navigationText: ['上一页', '下一页'],
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem:true,
      autoPlay: true,
      pagination: false
      // navigation: true
    });
  });

  /*====================================
  Portfolio Isotope Filter
  ======================================*/
  $(window).load(function() {
      var $container = $('#lightbox');
      $container.isotope({
          filter: '*',
          animationOptions: {
              duration: 750,
              easing: 'linear',
              queue: false
          }
      });
      $('.cat a').click(function() {
          $('.cat .active').removeClass('active');
          $(this).addClass('active');
          var selector = $(this).attr('data-filter');
          $container.isotope({
              filter: selector,
              animationOptions: {
                  duration: 750,
                  easing: 'linear',
                  queue: false
              }
          });
          return false;
      });

  });
}

export default {
  name: 'index',
  components: {
    'h-header': Header,
    'h-footer': Footer
  },
  data () {
    return {
      clientData: [
        {
          paginationImage: `${process.env.BASE_URL}/static/img/client/r1.png`,
          title:'基于模型的系统工程（MBSE）',
          swiperImage: `${process.env.BASE_URL}/static/img/client/定制.png`,
          active: true
        },
        {
          paginationImage: `${process.env.BASE_URL}/static/img/client/r1.png`,
          title:'数字孪生体模型',
          swiperImage: `${process.env.BASE_URL}/static/img/client/定制.png`
        },
        {
          paginationImage: `${process.env.BASE_URL}/static/img/client/r1.png`,
          title:'模型操作系统（ModelOS）',
          swiperImage: `${process.env.BASE_URL}/static/img/client/定制.png`
        },
        // {
        //   paginationImage: `${process.env.BASE_URL}/static/img/client/r1.png`,
        //   title:'数字孪生',
        //   swiperImage: `${process.env.BASE_URL}/static/img/client/定制.png`
        // },
      ]
    }
  },
  created () {
    if (this.$route.query.id) { this.detailId = this.$route.query.id }

  },
  mounted () {
    main()
  },
  methods: {
    chooseSwiper (index) {
      clientIns.trigger('owl.goTo', index)
      this.clientData = this.clientData.map((item) => {item.active = false; return item;})
      this.clientData[index].active = true
    },
    navigateTo (url) {
      this.$router.push(url)
    }
  }
}
</script>
<style scoped lang="scss">
@import 'index';
</style>
